export enum Role {
	STUDENT = 2,
	BUILDING_ADMIN = 5,
	DISTRICT_ADMIN = 6,
	FACULTY = 7
}
